module.exports = __webpack_public_path__ + "assets/Angle45Detailed.de0114128377dc7f5fb64faea975f4dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/Angle45Detailed.png
// module id = 461
// module chunks = 0